export const GRIND_MLO_DATA_URL =
  "https://othlpps.loanforceinsider.com/api/SignatureUser/pages";
